var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F3F3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6341 17.0583C15.5508 17.05 15.4508 17.05 15.3591 17.0583C13.3758 16.9916 11.8008 15.3666 11.8008 13.3666C11.8008 11.325 13.4508 9.66663 15.5008 9.66663C17.5424 9.66663 19.2008 11.325 19.2008 13.3666C19.1924 15.3666 17.6174 16.9916 15.6341 17.0583Z",
    stroke: "#2A3337",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6747 11.3334C23.2914 11.3334 24.5914 12.6417 24.5914 14.25C24.5914 15.825 23.3414 17.1084 21.7831 17.1667C21.7164 17.1584 21.6414 17.1584 21.5664 17.1667",
    stroke: "#2A3337",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4676 20.1334C9.45091 21.4834 9.45091 23.6834 11.4676 25.025C13.7592 26.5584 17.5176 26.5584 19.8092 25.025C21.8259 23.675 21.8259 21.475 19.8092 20.1334C17.5259 18.6084 13.7676 18.6084 11.4676 20.1334Z",
    stroke: "#2A3337",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2832 24.6666C23.8832 24.5416 24.4499 24.3 24.9165 23.9416C26.2165 22.9666 26.2165 21.3583 24.9165 20.3833C24.4582 20.0333 23.8999 19.8 23.3082 19.6666",
    stroke: "#2A3337",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.c3bb80fc2f6930450725aa6eb8c65232.svg";
export { ForwardRef as ReactComponent };